import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FloatingNavbar from '../components/FloatingNavbar';
import ScrollableContent from '../components/ScrollableContent';

const NakshatraLanding: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/horoscope', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="relative min-h-screen font-sans" style={{ background: '#CBB191', color: '#2B2017' }}>
      <FloatingNavbar />
      <ScrollableContent />
    </div>
  );
};

export default NakshatraLanding;
